  export function cleanSpaces(textArea) {
        return textArea.replace(/\s/g, '');
    }